import { faGears } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';

import { DeleteOrganizationForm } from '~/components/forms/DeleteOrganizationForm';
import { UpdateOrganizationForm } from '~/components/forms/OrganizationForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';

export type IOrganizationSettingsPageProps = {
  organizationId: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const OrganizationSettingsPage: React.FC<
  IOrganizationSettingsPageProps
> = (props) => {
  const { organizationId, nextUrl, cancelUrl } = props;
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Settings</title>
      </Helmet>

      <Heading icon={<FontAwesomeIcon icon={faGears} />} title="Settings" />

      <UpdateOrganizationForm
        organizationId={organizationId}
        onSuccess={(updatedOrganization) =>
          navigate(
            nextUrl ?? `/organizations/${updatedOrganization._id}/settings`,
          )
        }
        cancelUrl={cancelUrl ?? `/organizations/${organizationId}`}
      />
      <DeleteOrganizationForm
        organizationId={organizationId}
        onSuccess={() => navigate('/')}
        cancelUrl={cancelUrl ?? `/organizations/${organizationId}`}
      />
    </>
  );
};
